"use client"

import { Fragment, useEffect, useRef, useState, useMemo} from "react";
import { debounce } from "@/utils";
import ArrowIcon from "@/images/icon/arrow-default.svg";
const limitHeight = 300
const initialContentStyle = {
    height: `${limitHeight}px`,
    overflow: "hidden"
}
const recordBodyHeight = 0
export default function BrandStory ({ brandStoryData }: any) {
    const brandRefContainer = useRef<any>(null);
    const { title, data } = brandStoryData || {}
    const [isExceed, setIsExceed ] = useState<boolean>(false);
    const [isShowMore, setIsShowMore] = useState<boolean>(true);
    const contentStyle = useMemo<any>(()=> {
        if(isExceed) {
            if(isShowMore) {
                return initialContentStyle
            } else {
                return {}
            }
        } else {
            return {}
        }
        

    }, [isExceed, isShowMore])
    
    const calculateContainerHeight = ()=> {
        const h = brandRefContainer.current.offsetHeight
        if(h && h> 0) {
            setIsExceed(h> limitHeight)
        }
        
    }
    
    useEffect(()=> {
        const targetElement = document.getElementById("brandFloor");
        const resizeObserver = new ResizeObserver((entries) => {
            const fn = debounce(() => {
              if (recordBodyHeight !== entries[0].target.clientHeight) {
                calculateContainerHeight()
              }
            }, 0);
            fn();
          });
      
          targetElement && resizeObserver.observe(targetElement);
          return () => {
            resizeObserver.disconnect();
          };
        
    }, [])
    if(!data || data?.length === 0) {
        return null
    }
    return <div id="brandFloor" className="brand-floor">
        <div className="brand-title">{title}</div>
        <div className="brand-content" style={contentStyle}>
            <div ref={brandRefContainer} className="b-container">
                {data?.map((item: any, index: number)=> {
                    return <Fragment key={index}>{
                        item.type === "0" ? <img src={item.graphicUrl} alt={""} /> : <p className="text" dangerouslySetInnerHTML={{__html: item.textualDetail || ''}}></p>
                    }</Fragment>
                })}
            </div>
            { isExceed && <div className={`show ${ isShowMore ? 'see-more': "see-less"}`}>
                <p className="text" onClick={()=> setIsShowMore(!isShowMore)}>See { isShowMore ? 'more': "less"}<ArrowIcon /></p>
                </div>
            }
        </div>

    </div>
}